import React, { useEffect, useState } from 'react';
import { StyledBookDemoWrap } from './StyledBookDemoWrap';
import gsap from 'gsap';
import { BaseUrl } from "../../config";

const BookDemoWrap = ({ nextStep, index, img }) => {
  const [contactType, setContactType] = useState([]);
  const [inputIndex, setInputIndex] = useState(0);
  const [commentLength, setCommentLength] = useState(0);
  const [isSending, setIsSending] = useState(false);

  const createIubendaScript  = () => {
    var s = document.createElement("script"), 
    tag = document.getElementsByTagName("script")[0]; 
    s.src="https://cdn.iubenda.com/iubenda.js"; 
    s.id="iubenda--over";
    tag.parentNode.insertBefore(s,tag);

  }
  useEffect(() => {
    var iubendaScript = document.querySelector("#iubenda--over");
    if(!iubendaScript){
      createIubendaScript()
    }else{
      iubendaScript.parentNode.removeChild(iubendaScript)
      createIubendaScript()
    }

  },[]);

  useEffect(() => {

    if(index === 0){

      setContactType([]);
      setInputIndex(0)
      let formHeight = document.querySelector('.first--step').clientHeight;

      gsap.to('.form--step', {autoAlpha: 0, onComplete: () => {
        
        var selected = document.querySelectorAll('.contact--selection.selected')
        for (var i = 0; i < selected.length; i++){
          selected[i].classList.remove('selected')
        }

        gsap.set('.first--step', {position: 'relative'});
        
        gsap.to('.contact--slider', {height: formHeight, duration: .5, 

          onComplete: () => {
            gsap.set('.form--step', {position: 'absolute'});
            
            gsap.to('.first--step', {autoAlpha: 1,
              onComplete: () => {
                gsap.set('.contact--slider', {height: 'auto'});
              }
            });
          }
        });

      }})

    }else if(index > 0){
      const inputSteps = document.querySelectorAll('.input--wrap-step');

      gsap.to(inputSteps[inputIndex],{autoAlpha: 0, duration: .5, 
        onComplete: () => {
          for(var i = 0; i < inputSteps.length; i++){
            if(i > index){
              if(inputSteps[i].classList.contains('selected')) inputSteps[i].classList.remove('selected');

            }else{
              inputSteps[index - 1].classList.add('selected');
            } 
            
          }
          
          gsap.to(inputSteps[index - 1],{autoAlpha: 1, duration: .5, 
            onComplete: () => {
              
              setInputIndex(index - 1)
            }
          })
        }
      })
    }
  
  
}, [index])
  const firstStep = () => {

      gsap.to('.first--step', {autoAlpha: 0, onComplete: () => {
        nextStep()
        gsap.set('.form--step', {position: 'relative'});
        let formHeight = document.querySelector('.form--step').clientHeight;
        
        gsap.to('.contact--slider', {height: formHeight, duration: .5, 
          onComplete: () => {
            gsap.set('.first--step', {position: 'absolute'});
            gsap.to('.form--step', {autoAlpha: 1,
              onComplete: () => {
                gsap.set('.contact--slider', {height: 'auto'});
              }
            });
          }
        });
      }})
    }
  

  const addType = (event,type) => {
    event.currentTarget.classList.toggle('selected');
    
    if(event.currentTarget.classList.contains('selected')) setContactType([...contactType, type])
    else {
      setContactType(contactType.filter(item => item !== type));
    }
  }

  const removeError = (e) => {
    var parent = e.currentTarget.parentNode.parentNode;
    var errorText = parent.querySelector('.error-text')
    if(parent.classList.contains('error')) {
      parent.classList.remove('error')
      errorText.innerText = ""
    }
  }

  const checkInput = (event,type) => {
    var parent = event.currentTarget.parentNode.parentNode;
    var inputVal = parent.querySelector('input').value;
    var errorText = parent.querySelector('.error-text');
    var check = parent.querySelector('.check--terms');

    if (type == "surname") {
      var surParent = document.querySelector('#surname-parent')
      var inputArray = surParent.querySelectorAll('input')
      var errorArray = surParent.querySelectorAll('.error-text')
      var parentError = surParent.querySelectorAll('.input--wrap')
      for (var i = 0; i < inputArray.length; i++){
        if (inputArray[i].value.length === 0 || inputArray[i] === "") {
          errorArray[i].innerText = "Please fill in this field";
          parentError[i].classList.add('error')
        } else {
          if(i === inputArray.length - 1) nextInput()
        }
      }
      
    }
    if(type === "name"){
      if(inputVal.length === 0 || inputVal === ""){
        errorText.innerText = "Please fill in this field";
        parent.classList.add('error')
      }else{
        nextInput()
      }
    }
  

    if(type === "email"){
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(!re.test(inputVal)){
        errorText.innerText = "Please enter a valid e-mail";
        parent.classList.add('error')
      }else{
        nextInput()
      }
    }

    if (type === "last-step") {
      if(inputVal.length === 0 || inputVal === ""){
        errorText.innerText = "Please fill in this field";
        parent.classList.add('error')
      } else {
        if(!check.classList.contains('checked')){
          parent.classList.add('error')
          errorText.innerText = "Please accept our terms of use in order to send your inquiry";
        }else{
          setIsSending(true)
          send()
        }
      }
      
    }

  }

  const nextInput = () => {
    nextStep()
    const inputSteps = document.querySelectorAll('.input--wrap-step');

    gsap.to(inputSteps[inputIndex],{opacity: 0, duration: .5, 
      onComplete: () => {
        inputSteps[inputIndex].classList.remove('selected');
        inputSteps[inputIndex + 1].classList.add('selected');
        gsap.to(inputSteps[inputIndex + 1],{autoAlpha: 1, duration: .5, 
          onComplete: () => {
            
            setInputIndex(inputIndex + 1)
          }
        })
      }
    })
  }

  const commentsCheck = (e) => {
    var inputVal = e.currentTarget.value
     
    if(inputVal.length <= 300) setCommentLength(inputVal.length);
    else {
      e.preventDefault()
      inputVal.slice(0, 20)
    }
  }

  const checkTerms = (e) => {
    e.currentTarget.classList.toggle('checked')
    var parent = e.currentTarget.parentNode.parentNode;
    if(parent.classList.contains('error')) {
      var errorText = parent.querySelector('.error-text');
      errorText.innerText = "";
      parent.classList.remove('error')
    }
  }

  const send = () =>  {
    var name = document.getElementById('--name').value
    var surname = document.getElementById('--surname').value
    var email = document.getElementById('--email').value
    var company = document.getElementById('--company').value
    var role = document.getElementById('--role').value
    var comments = document.getElementById('--comments').value
    var country = document.getElementById('--country').value
    var subject = ""
    subject += contactType.map((key, index) => {
        return  `${key}`
      })
    

    var formData = new FormData();

    formData.append('key', 'invrsion');
    formData.append('subject', subject);
    formData.append('name', name);
    formData.append('surname', surname);
    formData.append('organization', company);
    formData.append('country', country);
    formData.append('mail', email);
    formData.append('role', role);
    formData.append('comments', comments);
    
    
    fetch(`${BaseUrl}/contact-form`, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if(response.status === 200){
        const inputSteps = document.querySelectorAll('.input--wrap-step');
        gsap.to('.form-type',{autoAlpha: 0, duration: .5, 
          onComplete: () => {
            gsap.set('.form-type', {display: "none" }) 
          } 
        })
        gsap.to('.img--wrap',{autoAlpha: 0, duration: .5, 
          onComplete: () => {
            gsap.set('.img--wrap', {display: "none" }) 
          } 
        })
        gsap.to('.indicator--wrap',{autoAlpha: 0, duration: .5, 
          onComplete: () => {
            gsap.set('.indicator--wrap', {display: "none" }) 
          }
        })
        gsap.to(inputSteps[inputIndex],{opacity: 0, duration: .5, 
          onComplete: () => {
            inputSteps[inputIndex].classList.remove('selected');
            inputSteps[inputIndex + 1].classList.add('selected');
            gsap.to(inputSteps[inputIndex + 1],{autoAlpha: 1, duration: .5, 
              onComplete: () => {
                setInputIndex(inputIndex + 1)
              }
            })
          }
        })
      }
    })

  }
  useEffect(() => {

    if(contactType.length > 0){
      gsap.to('.selection--next',{autoAlpha: 1, duration: .5})
    }else if(contactType.length === 0){
      gsap.to('.selection--next',{autoAlpha: 0, duration: .5})
    }
  },[contactType])
  return (
    <React.Fragment>
      {
       
        <StyledBookDemoWrap>
          <div className="contact--slider">
            <div className="contact--step first--step">
              <p className="preset-9 step-title">What are you interested in?</p>
              <div className="contact--selection-wrap">
                <div className="contact--selection" onClick={(event) => addType(event,'3D e-commerce')}>
                  <h6 className="md--title" >3D e-commerce</h6>
                </div>
                <div className="contact--selection" onClick={(event) => addType(event,'Metaverse')}>
                  <h6 className="md--title" >Metaverse</h6>
                </div>
                <div className="contact--selection" onClick={(event) => addType(event,'Shelfzone')}>
                  <h6 className="md--title" >Shelfzone</h6>
                </div>
                <div className="contact--selection" onClick={(event) => addType(event,'Virtual Showroom')}>
                  <h6 className="md--title" >Virtual Showroom</h6>
                </div>

                <div className="contact--selection" onClick={(event) => addType(event,'All')}>
                  <h6 className="md--title" >&nbsp;&nbsp;All&nbsp;&nbsp;</h6>
                </div>
                <div className="contact--selection" onClick={(event) => addType(event,'Other')}>
                  <h6 className="md--title" >Other</h6>
                </div>
                <div className="contact--selection selection--next" onClick={firstStep}>
                  <img src={require('../../assets/arrow-form.svg')} />
                </div>
              </div>
              <p className="preset-11 multiple-choice">*You can select one or more options </p>
            </div>
            <div className="contact--step form--step">
              <p className="preset-9 form-type ">You selected:&nbsp;
                { 
                  contactType.map((key, index) => {
                    return  <span key={index}>{ `${key}${index < (contactType.length - 1) ? ", " : ""}`}</span>
                  })

                }
              </p>
              <div className="form--wrap">

                <div className="input--wrap-step selected" id="surname-parent">
                  <h6 className="md--title" >What’s your first name?</h6>
                  <div className="input--wrap">
                    <div className="input--wrap-row">
                      <input type="text" id="--name" onFocus={removeError}/>
                    </div>
                    <div className="input--wrap-row error--message">
                      <p className="preset-11 error-text">&nbsp;</p>
                    </div>
                  </div>
                
                  <h6 className="md--title" >What’s your last name?</h6>
                  <div className="input--wrap">
                    <div className="input--wrap-row">
                      <input type="text" id="--surname" onFocus={removeError}/>
                      <img src={require('../../assets/arrow-form.svg')} onClick={(e) => checkInput(e,'surname')}/>
                    </div>
                    <div className="input--wrap-row error--message">
                      <p className="preset-11 error-text">&nbsp;</p>
                    </div>
                  </div>
                </div>

                <div className="input--wrap-step">
                  <h6 className="md--title" >What’s your email address?</h6>
                  <div className="input--wrap">
                    <div className="input--wrap-row">
                      <input type="email" id="--email" placeholder="Ex. test@email.com" onFocus={removeError}/>
                      <img src={require('../../assets/arrow-form.svg')} onClick={(e) => checkInput(e,'email')}/>
                    </div>
                    <div className="input--wrap-row error--message">
                      <p className="preset-11 error-text">&nbsp;</p>
                    </div>
                  </div>
                </div>
                <div className="input--wrap-step">
                  <h6 className="md--title" >Which country are you from?</h6>
                  <div className="input--wrap">
                    <div className="input--wrap-row">
                      <input type="text" id="--country" onFocus={removeError}/>
                      <img src={require('../../assets/arrow-form.svg')} onClick={(e) => checkInput(e,'name')}/>
                    </div>
                    <div className="input--wrap-row error--message">
                      <p className="preset-11 error-text">&nbsp;</p>
                    </div>
                  </div>
                </div>

                <div className="input--wrap-step">
                  <h6 className="md--title" >What organization are you with?</h6>
                  <div className="input--wrap">
                    <div className="input--wrap-row">
                      <input type="text" id="--company" onFocus={removeError}/>
                      <img src={require('../../assets/arrow-form.svg')} onClick={(e) => checkInput(e,'name')}/>
                    </div>
                    <div className="input--wrap-row error--message">
                      <p className="preset-11 error-text">&nbsp;</p>
                    </div>
                  </div>
                </div>

                <div className="input--wrap-step">
                  <h6 className="md--title" >What’s your role inside this company?</h6>
                  <div className="input--wrap">
                    <div className="input--wrap-row">
                      <input type="text" id="--role" onFocus={removeError}/>
                      <img src={require('../../assets/arrow-form.svg')} onClick={(e) => checkInput(e,'name')}/>
                    </div>
                    <div className="input--wrap-row error--message">
                      <p className="preset-11 error-text">&nbsp;</p>
                    </div>
                  </div>
                </div>

                <div className="input--wrap-step last-step">
                  <h6 className="md--title" >Do you have any further comments?</h6>
                  <div className="input--wrap">
                    <div className="input--wrap-row">
                      <input type="text" id="--comments" maxLength="300" onFocus={removeError} onKeyUp={commentsCheck}/>
                      {
                          !isSending &&
                          <img src={require('../../assets/arrow-form.svg')} onClick={(e) => checkInput(e,'last-step')}/>
                      }
                      {
                        isSending &&
                        <div className="loader"></div>
                      }                    </div>
                    <div className="input--wrap-row">
                      <p className="preset-11 comments-check">
                        <span>{commentLength}/300</span>
                      </p>
                    </div>
                    <div className="input--wrap-row terms--row">
                      <div className="check--terms" onClick={checkTerms}>
                        <img src={require('../../assets/check.svg')} />
                      </div>
                      <p className="preset-10" >By checking this box, you confirm that you read and are agreeing to our 
                      <a href="https://www.iubenda.com/privacy-policy/25080573" className="iubenda-nostyle no-brand iubenda-embed iub-legal-only" title="terms of use "> terms of use </a>
                       regarding the storage of the data submitted through this form</p>
                    </div>
                    <div className="input--wrap-row error--message">
                      <p className="preset-11 error-text">&nbsp;</p>
                    </div>
                  </div>
                </div>
                <div className="input--wrap-step thank--you">
                  <div className="thankyou-check">
                    <img src={require('../../assets/check.svg')} />
                  </div>
                  <h6 className="md--title" >Thank you!</h6>
                  <p className="preset-11">Your inquiry is very important to us and we’ll email you back ASAP!</p>
                </div>
              </div>
            </div>
          </div>
          <div className="img--wrap">
            {/* <img src={img} /> */}
          </div>
        </StyledBookDemoWrap>
          
      }
    </React.Fragment>
  );
};

export default BookDemoWrap;
